module.exports = __webpack_public_path__ + "static/media/ball_4_7.c52a0afc.mp3";